/**
 * Hands content to the browser as a file download, as if the user had followed a link to it. The
 * content is anything a `Blob` accepts — text, JSON, bytes — and `type` is its MIME type.
 */
export function downloadToBrowser(content: BlobPart, fileName: string, type: string): void {
  const url = window.URL.createObjectURL(new Blob([content], { type }));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
